/* eslint-disable */
<template>
	<div>
		<div style="text-align: left; padding-bottom: 10px;"><el-button @click="addCity"  type="primary">添加目的地</el-button></div>
		<div>
		<el-table :data="tableData" style="width: 100%" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
      		<el-table-column prop="cityName" label="城市名" width="100"></el-table-column>
      		<el-table-column prop="startPrice" label="起步价" width="100"></el-table-column>
      		<el-table-column prop="kgPrice" label="元/公斤" width="100"></el-table-column>
      		<el-table-column prop="tPrice" label="元/吨" width="100"></el-table-column>
      		<el-table-column prop="cubePrice" label="元/立方" width="100"></el-table-column>
      		<el-table-column label="是否中转" width="180">
      			<template slot-scope="scope">
      				<span v-if="scope.row.transferSign==0" >否</span>
      				<span v-if="scope.row.transferSign==1" >是</span>
      			</template>
      		</el-table-column>
      		<el-table-column label="状态" width="180">
      			<template slot-scope="scope">
      				<el-tag v-if="scope.row.state==0" type="danger">无效</el-tag>
      				<el-tag v-if="scope.row.state==1" type="success">有效</el-tag>
      			</template>
      		</el-table-column>
      		<el-table-column label="操作" width="250">
      			<template scope="scope">
					<el-button size="small" v-if="scope.row.state==0" @click="cityToVisiable(scope.$index, scope.row)">置为有效</el-button>
					<el-button size="small" v-if="scope.row.state==1" @click="cityToVisiable(scope.$index, scope.row)">置为失效</el-button>
					<el-button size="small" @click="cityUpdate(scope.$index, scope.row)">修改</el-button>
				</template>
      		</el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" :current-page="currentPage" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>


		</div>	
	</div>

	
</template>
<script >
	import {getCityList,updateCityState} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:15,
		 		total:0,
		 		pageCount:0,
		 		currentPage:0,
		 		lineId:""
		 	}
		},
		created:function() {
			var _this = this;
			var lineId = this.$route.query.lineId;
			this.lineId = lineId;
			let params = {pageNum:0,pageSize:this.pageSize,routeId:lineId};
			this.lineId = lineId;
			getCityList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
				this.currentPage = res.data.data.pageNum;
			});
			
		},
		methods:{
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize,routeId:this.lineId};
				getCityList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			reload(){
				let params = {pageNum:this.currentPage,pageSize:this.pageSize,routeId:this.lineId};
				getCityList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			
			cityUpdate(index,row){
				this.$router.push({name:"addCity",query:{id:row.id}});
			},
			addCity(index,row){
				var param = {};
				if(row!=null){
					param.id = row.id;
				}
				param.routeId=this.lineId;
				this.$router.push({name:"addCity",query:param});
			},
			cityToVisiable(index,row){
				let _this = this;
				let params={id:row.id};
				if(row.state==1){
					params.state=0;
				}else{
					params.state=1;
				}
				updateCityState(params).then(res=>{
					if(res.data.status=='success'){
						this.$message({
					            type: 'success',
					            message: '操作成功'
					         });
						_this.reload();
					}
				});
			}
		}
	}
</script>